import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import getPublicEnv from '@utils/getPublicEnv';
class NextShowroomApi {
  private endpoints = {
    getAllShowrooms: () => `showroom/allShowroom`,
    getShowroom: (uuid: string) => `showroom/${uuid}/showroom`,
    getPointByPimInternalId: (pimInternalId: string) => `showroom/${pimInternalId}/showroomByPimInternalId`
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async getAllShowroomsAndGeoData() {
    const method = 'GET';
    const {
      json
    } = await fetchNext(this.endpoints.getAllShowrooms(), {
      method
    }, NextShowroomApi.getLocale());
    return json;
  }
  public async getShowroom(uuid: string) {
    const method = 'GET';
    const {
      json
    } = await fetchNext(this.endpoints.getShowroom(uuid), {
      method
    }, NextShowroomApi.getLocale());
    return json;
  }
  public async getShowroomByPimInternalId(pimInternalId: string) {
    const method = 'GET';
    const {
      json,
      status
    } = await fetchNext(this.endpoints.getPointByPimInternalId(pimInternalId), {
      method
    }, NextShowroomApi.getLocale());
    if (status !== 200) {
      return null;
    }
    return json;
  }
}
export default new NextShowroomApi();